import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, isRef as _isRef, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-d-flex p-jc-between" }

import { defineAsyncComponent } from "vue";
import { usePoitings } from "./hooks/usePoitings";
import PointingView from "./PointingView.vue";
import SectorMultiselect from "../sector/SectorMultiselect.vue";
import { useSectors } from "../sector/hooks/useSectors";
import FunctionMultiselect from "../function/FunctionMultiselect.vue";
import { useFunctions } from "../function/hooks/useFunctions";


export default /*#__PURE__*/_defineComponent({
  __name: 'Pointings',
  setup(__props) {

const UpdatePointing = defineAsyncComponent(
  () => import("./UpdatePointing.vue")
);

const CreatePointing = defineAsyncComponent(
  () => import("./CreatePointing.vue")
);

const {
  loading,
  employees,
  viewOptions,
  monthOfYear,
  columns,
  pointingLoging,
  filter,
  selection,
  viewOption,
  findPointage,
  dialogs,
  handleCreate,
  handleUpdate,
  handleCreateAll,
} = usePoitings();

const { sectors } = useSectors();
const { functions } = useFunctions();

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_SplitButton = _resolveComponent("SplitButton")!
  const _component_Toolbar = _resolveComponent("Toolbar")!
  const _component_Column = _resolveComponent("Column")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Toolbar, { class: "p-mb-2" }, {
      start: _withCtx(() => [
        _createVNode(_component_Button, {
          onClick: _unref(handleCreateAll),
          label: "Pointer les employés sélectionnés",
          icon: "pi pi-plus",
          class: "mr-2",
          disabled: !_unref(selection).length
        }, null, 8, ["onClick", "disabled"])
      ]),
      end: _withCtx(() => [
        _createElementVNode("form", _hoisted_1, [
          _createVNode(_component_Calendar, {
            modelValue: _unref(monthOfYear),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(monthOfYear) ? (monthOfYear).value = $event : null)),
            view: "month",
            dateFormat: "MM yy",
            yearNavigator: true,
            showIcon: true,
            maxDate: new Date(),
            class: "p-mr-2",
            placeholder: _ctx.$t('date'),
            loading: _unref(pointingLoging),
            disabled: _unref(pointingLoging)
          }, null, 8, ["modelValue", "maxDate", "placeholder", "loading", "disabled"]),
          _createVNode(_component_SplitButton, {
            label: "Affchage",
            model: _unref(viewOptions),
            class: "p-button-success"
          }, null, 8, ["model"])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_DataTable, {
      value: _unref(employees),
      responsiveLayout: "scroll",
      class: "p-datatable-sm",
      loading: _unref(loading),
      showGridlines: "",
      dataKey: "id",
      rowHover: false,
      filters: _unref(filter),
      "onUpdate:filters": _cache[1] || (_cache[1] = ($event: any) => (_isRef(filter) ? (filter).value = $event : null)),
      filterDisplay: "menu",
      globalFilterFields: [
      'firstName',
      'lastName',
      'function.name',
      'sector.name',
    ],
      selection: _unref(selection),
      "onUpdate:selection": _cache[2] || (_cache[2] = ($event: any) => (_isRef(selection) ? (selection).value = $event : null))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Column, {
          selectionMode: "multiple",
          headerStyle: { width: '3em' }
        }),
        _createVNode(_component_Column, {
          showFilterMatchModes: false,
          "show-add-button": false,
          showFilterOperator: false,
          field: "sector.name",
          filterField: "sector.id",
          header: _ctx.$t('sector'),
          sortable: "",
          sortField: "sector.id"
        }, {
          filter: _withCtx(({ filterModel }) => [
            _createVNode(SectorMultiselect, {
              modelValue: filterModel.value,
              "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
              options: _unref(sectors),
              style: {"max-width":"220px"}
            }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
          ]),
          filterclear: _withCtx(({ filterCallback }) => [
            _createVNode(_component_Button, {
              type: "button",
              onClick: ($event: any) => (filterCallback()),
              class: "p-button-warning p-mr-1 p-button-sm",
              label: _ctx.$t('prime.clear')
            }, null, 8, ["onClick", "label"])
          ]),
          filterapply: _withCtx(({ filterCallback }) => [
            _createVNode(_component_Button, {
              label: _ctx.$t('search'),
              type: "button",
              icon: "pi pi-search",
              class: "p-button-sm",
              onClick: ($event: any) => (filterCallback())
            }, null, 8, ["label", "onClick"])
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_Column, {
          showFilterMatchModes: false,
          "show-add-button": false,
          showFilterOperator: false,
          field: "function.name",
          filterField: "function.id",
          header: _ctx.$t('function'),
          sortable: "",
          sortField: "function.id"
        }, {
          filter: _withCtx(({ filterModel }) => [
            _createVNode(FunctionMultiselect, {
              modelValue: filterModel.value,
              "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
              options: _unref(functions),
              style: {"max-width":"220px"}
            }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
          ]),
          filterclear: _withCtx(({ filterCallback }) => [
            _createVNode(_component_Button, {
              type: "button",
              onClick: ($event: any) => (filterCallback()),
              class: "p-button-warning p-mr-1 p-button-sm",
              label: _ctx.$t('prime.clear')
            }, null, 8, ["onClick", "label"])
          ]),
          filterapply: _withCtx(({ filterCallback }) => [
            _createVNode(_component_Button, {
              label: _ctx.$t('search'),
              type: "button",
              icon: "pi pi-search",
              class: "p-button-sm",
              onClick: ($event: any) => (filterCallback())
            }, null, 8, ["label", "onClick"])
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_Column, {
          field: "lastName",
          header: _ctx.$t('hr_last_name'),
          "show-add-button": false,
          showFilterOperator: false,
          filterField: "lastName",
          sortable: ""
        }, {
          filter: _withCtx(({ filterModel }) => [
            _createVNode(_component_InputText, {
              type: "text",
              modelValue: filterModel.value,
              "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
              class: "p-column-filter",
              placeholder: 
            _ctx.$t('filterBy', { field: _ctx.$t('hr_last_name').toLowerCase() })
          
            }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"])
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_Column, {
          field: "firstName",
          header: _ctx.$t('hr_fistname'),
          "show-add-button": false,
          showFilterOperator: false,
          filterField: "firstName",
          sortable: ""
        }, {
          filter: _withCtx(({ filterModel }) => [
            _createVNode(_component_InputText, {
              type: "text",
              modelValue: filterModel.value,
              "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
              class: "p-column-filter",
              placeholder: 
            _ctx.$t('filterBy', { field: _ctx.$t('hr_fistname').toLowerCase() })
          
            }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"])
          ]),
          _: 1
        }, 8, ["header"]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(columns).slice(4), (col) => {
          return (_openBlock(), _createBlock(_component_Column, {
            field: col.field,
            header: col.header,
            key: col.field
          }, {
            body: _withCtx(({ data, field }) => [
              _createVNode(PointingView, {
                pointing: _unref(findPointage)(data.id, field),
                viewOption: _unref(viewOption),
                onCreatePointing: ($event: any) => (_unref(handleCreate)(data, field)),
                onUpdatePointing: ($event: any) => (_unref(handleUpdate)($event, data)),
                date: field
              }, null, 8, ["pointing", "viewOption", "onCreatePointing", "onUpdatePointing", "date"])
            ]),
            _: 2
          }, 1032, ["field", "header"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["value", "loading", "filters", "selection"]),
    (_unref(dialogs).create)
      ? (_openBlock(), _createBlock(_unref(CreatePointing), {
          key: 0,
          "created-at": _unref(dialogs).createdAt,
          employees: _unref(dialogs).employees,
          visible: _unref(dialogs).create,
          "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_unref(dialogs).create) = $event)),
          onOnCreated: _cache[4] || (_cache[4] = ($event: any) => (selection.value = [])),
          type: _unref(dialogs).type
        }, null, 8, ["created-at", "employees", "visible", "type"]))
      : _createCommentVNode("", true),
    (_unref(dialogs).update)
      ? (_openBlock(), _createBlock(_unref(UpdatePointing), {
          key: 1,
          pointing: _unref(dialogs).pointing,
          visible: _unref(dialogs).update,
          "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((_unref(dialogs).update) = $event)),
          employees: _unref(dialogs).employees
        }, null, 8, ["pointing", "visible", "employees"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})